<template>
<div class="details-invoice__wrapper">
  <a-t-loader v-if="isLoadComponent"/>

  <template v-else>
      <div class="main-content">
        <div class="container-lg">
          <div class="details-invoice">
            <div class="details-invoice__top">
              <div class="top__logo">
                <img src="/images/itinerary-logo.svg" alt="" />
              </div>
              <div class="top__desc-invoice">
                <div class="name">
                  <span class="invoice-name"> Invoice № </span>
                  <span class="invoice-number">
                  {{ currentInvoice.invoiceNumber }}
                </span>
                </div>

                <div
                    class="status"
                    :class="[
                    {paid: currentInvoice.status === 'PAID'},
                    {sent: currentInvoice.status === 'SENT'},
                    {cancel: currentInvoice.status === 'CANCEL'},
                    {refund: currentInvoice.status === 'REFUND'},
                    {'partially-paid': currentInvoice.status === 'PARTIALLY'},
                  ]">
                  <span class="name">Status:</span>
                  <svg v-if="currentInvoice.status === 'PARTIALLY'" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_4893_4639" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="8">
                      <rect width="8" height="8" rx="4" fill="#FFDA44"/>
                    </mask>
                    <g mask="url(#mask0_4893_4639)">
                      <rect width="8" height="8" rx="4" fill="#D7D7D7"/>
                      <rect x="-3" y="-3" width="7" height="12" fill="#77B017"/>
                    </g>
                  </svg>
                  <div class="circle"></div>
                  <span v-if="currentInvoice.status === 'PAID'" class="type"
                  >Paid</span
                  >
                  <span v-if="currentInvoice.status === 'SENT'" class="type"
                  >Not Paid</span
                  >
                  <span v-if="currentInvoice.status === 'CANCEL'" class="type"
                  >Cancel</span
                  >
                  <span v-if="currentInvoice.status === 'REFUND'" class="type"
                  >Refund</span
                  >
                  <span v-if="currentInvoice.status === 'PARTIALLY'" class="type"
                  >Partially Paid</span
                  >
                </div>

              </div>
            </div>
            <div class="details-invoice__bank">
              <div class="bank-block">

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Beneficiary</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Company Name:</span>
                        <svg @click="copyText(currentBank.companyName)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.companyName }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.companyName)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>IBAN Account:</span>
                        <svg @click="copyText(currentBank.ibanAccount.split(' ').join(''))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.ibanAccount }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.ibanAccount.split(' ').join(''))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Company Address: </span>
                        <svg @click="copyText(currentBank.beneficiaryAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.beneficiaryAddress }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.beneficiaryAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Bank of Beneficiary</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>SWIFT:</span>
                        <svg @click="copyText(currentBank.swift)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.swift }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.swift)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Bank Name:</span>
                        <svg @click="copyText(currentBank.bankAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.name }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.name)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Bank Address:</span>
                        <svg @click="copyText(currentBank.bankAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.bankAddress }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.bankAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentBank.accountNumber" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Account Number:</span>
                        <svg @click="copyText(currentBank.accountNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.accountNumber }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.accountNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentBank.sortCode" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Sort Code:</span>
                        <svg @click="copyText(currentBank.sortCode)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.sortCode }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.sortCode)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentBank.routingNumber" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Routing Number:</span>
                        <svg @click="copyText(currentBank.routingNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.routingNumber }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.routingNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentBank.accountType" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>Account Type:</span>
                        <svg @click="copyText(currentBank.accountType)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name">{{ currentBank.accountType }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentBank.accountType)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Payer:</span>
                    <span class="content-block_desc">{{currentInvoice.payer.payerType === 'OPERATOR' ? currentInvoice.payer.operator.companyName : currentInvoice.payer.participant}}</span>
                  </div>
                  <div class="content-block" v-if="(
                      currentInvoice.payer.payerType === 'OPERATOR') &&
                      (currentInvoice.payer.operator.tin.length !== 0 || currentInvoice.payer.operator.vrn.length !== 0 || currentInvoice.payer.operator.phone.length !== 0 || currentInvoice.payer.operator.address.length !== 0)
                    ">
                    <div class="content-block_name">
                      <span>TIN:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.tin }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>VRN:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.vrn }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Mobile:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.phone }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Address:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.address }}</span>
                    </div>
                  </div>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Behalf of:</span>
                    <span class="content-block_desc">
                      <span
                          class="clients-pax__disc"
                          v-for="(p, index) in behalfList"
                          :key="p.participantId"
                          :class="{'participant--deleted': p.warn}"

                      >
                      <template v-if="!p.warn">{{p.participantName}}<template v-if="behalfList.length !== index + 1">, </template></template>
                      <template v-if="p.warn">{{p.participantName}} (Deleted)<template v-if="behalfList.length !== index + 1">, </template></template>
                    </span>
                    </span>
                  </div>
                  <div class="content-block" v-if="(
                      currentInvoice.payer.payerType === 'OPERATOR') &&
                      (currentInvoice.payer.operator.tin.length !== 0 || currentInvoice.payer.operator.vrn.length !== 0 || currentInvoice.payer.operator.phone.length !== 0 || currentInvoice.payer.operator.address.length !== 0)
                    ">
                    <div class="content-block_name">
                      <span>TIN:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.tin }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>VRN:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.vrn }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Mobile:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.phone }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Address:</span>
                      <span class="sub-name">{{ currentInvoice.payer.operator.address }}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="details-invoice__payer">
              <div class="payer__services">
                <div class="payer-services-header">
                  <div class="services-header_title">
                    <span>Description of Services</span>
                  </div>
                  <div class="services-header_qty">
                    <span>Qty</span>
                  </div>
                  <div class="services-header_price">
                    <span>Price</span>
                  </div>
                  <div class="services-header_date">
                    <span>Dates</span>
                  </div>
                  <div class="services-header_amount">
                    <span>Amount</span>
                  </div>
                  <div class="services-header_amount">
                    <span>To be paid</span>
                  </div>
                </div>
                <div
                    class="payer-services-body"
                    v-for="service in currentInvoice.services" :key="service.id">
                  <div class="body__item-description">
                    <svg v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                    >
                    <svg v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                    >
                    <svg v-if="service.type === 'AIRPORT_VIP_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                    >
                    <svg v-if="service.type === 'TRANSFER'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                    >
                    <svg v-if="service.type === 'FLIGHT'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                    >
                    <svg v-if="service.type === 'MAINLAND'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                    >
                    <svg v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                    >
                    <svg v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                    >
                    <svg v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                    >
                    <svg v-if="service.type === 'EXTRA_ACCOMMODATION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                    >
                    <span>{{ service.name }}</span>
                  </div>
                  <div class="body__item-qty">
                    <span>{{ service.quantity }}</span>
                  </div>
                  <div class="body__item-price">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.price) }}</span>
                  </div>
                  <div class="body__item-date">
                    <span>{{ parseDateToString(service.startDate) }} </span>
                    <span>{{ parseDateToString(service.endDate) }}</span>
                  </div>
                  <div class="body__item-amount">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.amount) }}</span>
                  </div>
                  <div class="body__item-payable">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.amountPayable) }}</span>
                  </div>
                </div>
              </div>
              <div class="payer__total-inner">
                <div v-if="currentInvoice.currencyType === 'USD'" class="payer__total-draft"></div>
                <div v-if="currentInvoice.currencyType !== 'USD'" class="payer__total-desc">
                  <div class="logos">
                    <svg class="dollars" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0C4.47737 0 0 4.47737 0 10C0 15.5226 4.47737 20 10 20C15.5226 20 20 15.5226 20 10C20 4.47737 15.5226 0 10 0ZM12.8724 13.9424C12.4362 14.4733 11.8683 14.8313 11.2058 15.0123C10.9177 15.0905 10.786 15.2428 10.8025 15.5432C10.8148 15.8395 10.8025 16.1317 10.7984 16.428C10.7984 16.6914 10.6626 16.8313 10.4033 16.8395C10.2346 16.8436 10.0658 16.8477 9.89712 16.8477C9.74897 16.8477 9.60082 16.8477 9.45267 16.8436C9.17284 16.8395 9.04115 16.679 9.04115 16.4074C9.03704 16.1934 9.03704 15.9753 9.03704 15.7613C9.03292 15.284 9.01646 15.2675 8.55967 15.1934C7.97531 15.0988 7.39918 14.9671 6.8642 14.7078C6.44444 14.5021 6.39918 14.3992 6.51852 13.9547C6.60905 13.6255 6.69959 13.2963 6.80247 12.9712C6.87654 12.7325 6.9465 12.6255 7.07407 12.6255C7.14815 12.6255 7.2428 12.6626 7.37037 12.7284C7.96296 13.037 8.59259 13.2099 9.25514 13.2922C9.36625 13.3045 9.47737 13.3128 9.58848 13.3128C9.89712 13.3128 10.1975 13.2551 10.4897 13.1276C11.2263 12.8066 11.3416 11.9547 10.7202 11.4444C10.5103 11.2716 10.2675 11.144 10.0165 11.0329C9.37037 10.749 8.69959 10.535 8.09054 10.1687C7.10288 9.57613 6.47737 8.76543 6.55144 7.56379C6.63375 6.20576 7.40329 5.35802 8.65021 4.90535C9.16461 4.72016 9.16873 4.72428 9.16873 4.1893C9.16873 4.00823 9.16461 3.82716 9.17284 3.64198C9.18519 3.23868 9.25103 3.16872 9.65432 3.15638C9.69959 3.15638 9.74897 3.15638 9.79424 3.15638C9.87243 3.15638 9.95062 3.15638 10.0288 3.15638C10.0617 3.15638 10.0947 3.15638 10.1235 3.15638C10.8889 3.15638 10.8889 3.1893 10.893 4.01646C10.8971 4.62551 10.8971 4.62551 11.5021 4.72016C11.9671 4.79424 12.4074 4.93004 12.8354 5.11934C13.07 5.22222 13.1605 5.38683 13.0864 5.63786C12.9794 6.00823 12.8765 6.38272 12.7613 6.74897C12.6872 6.97119 12.6173 7.07407 12.4856 7.07407C12.4115 7.07407 12.321 7.04527 12.2058 6.98765C11.6132 6.69959 10.9918 6.55967 10.3416 6.55967C10.2593 6.55967 10.1728 6.56379 10.0905 6.5679C9.89712 6.58025 9.70782 6.60494 9.52675 6.68313C8.88477 6.96296 8.78189 7.67078 9.32922 8.107C9.60494 8.32922 9.92181 8.4856 10.2469 8.6214C10.8148 8.85597 11.3827 9.0823 11.9218 9.3786C13.6173 10.3251 14.0782 12.4774 12.8724 13.9424Z" fill="#77B017"/>
                    </svg>
                    <svg v-if="currentInvoice.currencyType === 'EUR'" class="euro" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0C4.47737 0 0 4.47737 0 10C0 15.5226 4.47737 20 10 20C15.5226 20 20 15.5226 20 10C20 4.47737 15.5226 0 10 0ZM13.4897 15.0658C13.1893 15.2016 12.8765 15.3169 12.5556 15.4033C11.3374 15.7407 10.1193 15.7531 8.90535 15.358C7.44033 14.8848 6.46914 13.8848 5.88889 12.4856C5.77778 12.214 5.7037 11.93 5.61728 11.6461H4.46914C4.27572 11.6461 4.12346 11.4897 4.12346 11.3004V10.5267C4.12346 10.3333 4.27984 10.1811 4.46914 10.1811H5.41975C5.41975 9.96708 5.41975 9.76543 5.41975 9.55144H4.46914C4.27572 9.55144 4.12346 9.39506 4.12346 9.20576V8.4321C4.12346 8.23868 4.27984 8.08642 4.46914 8.08642H5.67901L5.72016 7.96708C6.04527 6.93416 6.60494 6.04938 7.46502 5.38272C8.14815 4.85185 8.93827 4.55967 9.78601 4.42387C10.9918 4.23045 12.1605 4.39506 13.2922 4.83951C13.3663 4.86831 13.4362 4.90123 13.5062 4.94239C13.7778 5.10288 13.8477 5.30453 13.7284 5.59671C13.6008 5.90123 13.4733 6.20988 13.3333 6.51029C13.214 6.76955 13.0494 6.85185 12.7695 6.79012C12.3868 6.7037 12.0123 6.58436 11.6296 6.50617C10.823 6.34156 10.0206 6.33333 9.23457 6.64198C8.55967 6.90946 8.14815 7.42387 7.86831 8.06584C7.8642 8.07407 7.8642 8.0823 7.8642 8.09054H10.214C10.4074 8.09054 10.5597 8.24691 10.5597 8.43621V9.20988C10.5597 9.40329 10.4033 9.55556 10.214 9.55556H7.53086C7.52675 9.76132 7.53086 9.96708 7.53086 10.1852H10.2181C10.4115 10.1852 10.5638 10.3416 10.5638 10.5309V11.3045C10.5638 11.4979 10.4074 11.6502 10.2181 11.6502H7.76543C8.06173 12.4979 8.54321 13.1523 9.44856 13.4362C10.1728 13.6626 10.9012 13.6502 11.6337 13.4979C12.0123 13.4198 12.3827 13.3045 12.7613 13.2181C13.0576 13.1523 13.2181 13.2305 13.3416 13.5021C13.4815 13.8066 13.6132 14.1152 13.7366 14.428C13.8519 14.7078 13.7778 14.9342 13.4897 15.0658Z" fill="#606060"/>
                    </svg>
                    <svg v-if="currentInvoice.currencyType === 'GBP'" class="gbp" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0.625C8.1458 0.625 6.33324 1.17483 4.79153 2.20497C3.24982 3.23511 2.04821 4.69929 1.33863 6.41234C0.629062 8.1254 0.443406 10.0104 0.805142 11.829C1.16688 13.6475 2.05976 15.318 3.37088 16.6291C4.682 17.9402 6.35246 18.8331 8.17103 19.1949C9.9896 19.5566 11.8746 19.3709 13.5877 18.6614C15.3007 17.9518 16.7649 16.7502 17.795 15.2085C18.8252 13.6668 19.375 11.8542 19.375 10C19.375 8.76886 19.1325 7.54977 18.6614 6.41234C18.1902 5.27492 17.4997 4.24142 16.6291 3.37087C15.7586 2.50032 14.7251 1.80977 13.5877 1.33863C12.4502 0.867492 11.2311 0.625 10 0.625V0.625ZM12.5292 14.7413H7.08334C6.95453 14.7412 6.82887 14.7014 6.72356 14.6272C6.61825 14.5531 6.53842 14.4482 6.49501 14.3269C6.45159 14.2057 6.4467 14.0739 6.48101 13.9498C6.51532 13.8256 6.58715 13.7151 6.68667 13.6333L8.86 11.8479C8.70375 11.6058 8.50209 11.2937 8.295 10.9729H7.08334C6.91758 10.9729 6.75861 10.9071 6.6414 10.7899C6.52419 10.6726 6.45834 10.5137 6.45834 10.3479C6.45834 10.1822 6.52419 10.0232 6.6414 9.90597C6.75861 9.78876 6.91758 9.72292 7.08334 9.72292H7.5C7.4125 9.58292 7.33542 9.45917 7.28625 9.37667C7.0333 8.93315 6.89818 8.43223 6.89375 7.92167C6.89362 7.2754 7.11008 6.64773 7.50855 6.13892C7.90702 5.63011 8.46452 5.26952 9.09198 5.11476C9.71944 4.95999 10.3807 5.01997 10.97 5.28512C11.5594 5.55027 12.0429 6.00529 12.3433 6.5775C12.4207 6.7242 12.4366 6.89562 12.3876 7.05405C12.3385 7.21248 12.2286 7.34494 12.0819 7.42229C11.9352 7.49965 11.7638 7.51556 11.6053 7.46652C11.4469 7.41749 11.3144 7.30753 11.2371 7.16083C11.0668 6.83588 10.7924 6.57741 10.4579 6.42673C10.1234 6.27605 9.748 6.24186 9.39177 6.32962C9.03553 6.41738 8.719 6.62203 8.49276 6.91086C8.26652 7.19969 8.14364 7.55603 8.14375 7.92292C8.14783 8.20703 8.22136 8.48583 8.35792 8.735C8.46917 8.92042 8.70959 9.3 8.98042 9.72417H11.2475C11.4133 9.72417 11.5722 9.79001 11.6894 9.90722C11.8067 10.0244 11.8725 10.1834 11.8725 10.3492C11.8725 10.5149 11.8067 10.6739 11.6894 10.7911C11.5722 10.9083 11.4133 10.9742 11.2475 10.9742H9.78375C10.0296 11.3537 10.2088 11.6304 10.2142 11.6383C10.2979 11.7672 10.3311 11.9225 10.3076 12.0743C10.2841 12.2262 10.2054 12.3641 10.0867 12.4617L8.83042 13.4937H12.5292C12.6949 13.4937 12.8539 13.5596 12.9711 13.6768C13.0883 13.794 13.1542 13.953 13.1542 14.1187C13.1542 14.2845 13.0883 14.4435 12.9711 14.5607C12.8539 14.6779 12.6949 14.7437 12.5292 14.7437V14.7413Z" fill="#606060"/>
                    </svg>
                  </div>
                  <div class="content">
                    <span v-if="currentInvoice.currencyType === 'EUR'">The cost of our tours in Tanzania is pegged to US dollar. The price in EUR is tentative and valid for 14 days <span class="sub-text">since the day the invoice was issued.</span></span>
                    <span v-if="currentInvoice.currencyType === 'GBP'">The cost of our tours in Tanzania is pegged to US dollar. The price in GBP is tentative and valid for 14 days <span class="sub-text">since the day the invoice was issued.</span></span>
                  </div>
                </div>
                <div class="payer__block">
                  <div class="payer__total">
                    <div class="total-name">
                      <span>Current Deposit:</span>
                    </div>
                    <div class="total-result">
                      <template v-if="currentInvoice.currentDeposit">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.currentDeposit === null
                              ? ''
                              : numberWithCommas(currentInvoice.currentDeposit)
                        }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                  <div class="payer__total">
                    <div class="total-name">
                      <span>Total amount:</span>
                    </div>
                    <div class="total-result">
                      <template v-if="currentInvoice.totalAmount">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.totalAmount === null
                              ? ''
                              : numberWithCommas(currentInvoice.totalAmount)
                        }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                  <div class="payer__total">
                    <div class="total-name">
                      <span>Amount Payable:</span>
                    </div>
                    <div class="total-result">
                      <template v-if="currentInvoice.totalAmountPayable">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.totalAmountPayable === null
                              ? ''
                              : numberWithCommas(currentInvoice.totalAmountPayable)
                        }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div v-if="currentInvoice.currencyType !== 'USD'" class="details-invoice__note">
              <span class="note__title">NOTE:</span>
              <span v-if="currentInvoice.currencyType === 'EUR'" class="note__desc">* {{createDateChangePassword(currentInvoice.createdAt)}}: 1 Euro = {{currentInvoice.exchangeRateUSD}} USD. Total Amount: ${{numberWithCommas(currentInvoice.totalAmountUSD)}}</span>
              <span v-if="currentInvoice.currencyType === 'GBP'" class="note__desc">* {{createDateChangePassword(currentInvoice.createdAt)}}: 1 GBP = {{currentInvoice.exchangeRateUSD}} USD. Total Amount: ${{numberWithCommas(currentInvoice.totalAmountUSD)}}</span>
            </div>

            <div class="details-invoice__descriptions">
              <div class="descriptions__block">
                <span>Note: Bank commissions of the Payer's and Receiver's bank are payable by the Payer.</span>
                <span>By paying this bill, you are accepting our Terms and Conditions: <a target="_blank" href="https://altezza.travel/en/terms-and-conditions">https://altezza.travel/en/terms-and-conditions</a></span>
              </div>
              <div class="descriptions__confirm">
                AMOUNT PAYABLE:
                <template v-if="currentInvoice.totalAmountPayable">
                  <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                  <span>{{currentInvoice.totalAmountPayable === null ? '': numberWithCommas(currentInvoice.totalAmountPayable)}}</span>
                </template>
                <span v-else> 0 </span>
                should be paid before
                <span v-if="currentInvoice.deadline">
                    {{
                    currentInvoice.deadline === null
                        ? ''
                        : parseDateToString(currentInvoice.deadline)
                  }}
                  </span>
                <template v-else> ( Веберете дату ) </template>
                in order to confirm your booking.

              </div>
            </div>


          </div>
        </div>
      </div>
  </template>
  <div class="modal-wrapper" v-if="isModalCopy">
    <div class="modal-backdrop"></div>
    <div class="modal-inner">
      <div class="edit-popup edit-popup--copy-link edit-popup--copy-link__invoice-shared">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            <div class="edit-popup__title__icon">
              <svg width="1em" height="1em" class="icon icon-link">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link"></use>
              </svg>
            </div>
            <span>Text is copied to clipboard</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vuex from "vuex";

import ATLoader from "@/components/Loaders/Loader";
import {actionTypes as actionTypesInvoice, getterTypes as getterTypesInvoice} from "@/store/modules/invoices";
import {actionTypes as actionTypesBanks, getterTypes as getterTypesBanks} from "@/store/modules/banks";
import {format, parse} from "date-fns";
import {getCurrencySign} from '../../common/helpers/currency'

export default {
  name: "AtDetailsInvoice",
  components: {ATLoader},
  data() {
    return {
      isModalCopy: false,
      // currentInvoice: null,
      isLoadComponent: true,
      currentBank: {}
    }
  },
  computed: {
    ...Vuex.mapGetters({
      currentInvoice: getterTypesInvoice.currentInvoice,
      allBanks: getterTypesBanks.allBanks,
      behalfList: getterTypesInvoice.behalfList
    })
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findCurrentInvoice: actionTypesInvoice.findCurrentInvoice,
      findBanks: actionTypesBanks.findBanks,
      getBehalfList: actionTypesInvoice.getBehalfList
    }),
    getCurrentInvoice() {
      this.findCurrentInvoice({
        id: +this.$route.params.id
      }).then(() => {
        this.findAllBanks()
        this.findBehalfList()

      })
    },
    findBehalfList(){
      this.getBehalfList({
        clientId: this.currentInvoice.clientId,
        behalfOf: this.currentInvoice.behalfOf
      })
    },
    findAllBanks() {
      this.findBanks().then(() => {
        this.currentBank = this.allBanks.find(b => b.id === this.currentInvoice.bankId),
        this.isLoadComponent = false
      })
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    createDateChangePassword(date) {
      let options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      return new Date(date).toLocaleString('en-GB', options)
    },
    copyText(text){
      this.$clipboard(text)
      this.isModalCopy = true

      setTimeout(() => {
        this.isModalCopy = false
      }, 1000)
    },
  },
  mounted() {
    this.getCurrentInvoice()
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .modal-inner {
    padding: 25rem;
    .result-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        display: flex;
        align-items: center;

        padding-bottom: 20px;
        span {
          padding-left: 10px;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          text-align: center;

          color: #0C0C0C;
        }
      }
      .desc {
        text-align: center;

        padding-bottom: 20px;
        span {
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          text-align: center;

          color: #0C0C0C;
        }
      }
    }
  }
}
</style>
